import { LocationOn } from '@mui/icons-material';
import { Box } from '@mui/material';

const SearchBoxOption = ({ option }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      data-testid="AddressAutocompleteOption.Box"
    >
      <Box>
        <LocationOn color="success" />
      </Box>
      <Box ml="1rem">
        <Box fontSize="1rem">{option.address}</Box>
        <Box fontSize="0.75rem">{option.place_formatted}</Box>
      </Box>
    </Box>
  );
};
export default SearchBoxOption;
